<template>
  <div class="division_vote">
    <div class="imgvotes">
      <van-swipe :autoplay="5000" indicator-color="#3562FF">
        <van-swipe-item>
          <img :src="billist.listCover" alt="" title="" />
        </van-swipe-item>
      </van-swipe>
      <div class="activity_details_swiper_span">
        <!-- <span class="page_data_item_img1" v-if="activeState == 1">未开始</span> -->
        <span class="page_data_item_img2">{{ billist.listStatus }}</span>
        <!-- <span class="page_data_item_img3" v-else-if="activeState == 3">已结束</span> -->
      </div>
    </div>
    <div class="divisionName">
      <p>{{ billist.areaName }}</p>
    </div>
    <div class="tab_listvote">
      <van-tabs class="tasb">
        <van-tab :title="$t('message.home.Vote')">
          <p style="font-size: 12px; color: darkgray; padding: 10px">
            {{ $t('message.home.onlyvotes10') }}
          </p>
          <div class="area_left" v-if="fiaTwo && flagv == true">
            <van-checkbox-group v-model="result" @change="itemClick">
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in areaNamelist"
                  clickable
                  :key="item.listDivisionId"
                  :title="`${item.areaName}`"
                  @click="toggle(index)"
                >
                  <template #right-icon>
                    <van-checkbox :name="item" v-model="item.listDivisionId" ref="checkboxes" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <div class="left" v-if="flagv == false">
            {{ $t('message.home.Voted') }}
          </div>
          <div class="zdy" v-if="billist.userDefined" @click="chang">+自定义</div>
          <van-dialog
            v-model="show"
            title="自定义榜单"
            show-cancel-button
            @confirm="chargeBtn"
            :cancel="cancelClick"
          >
            <!--输入框-->
            <van-field v-model="message" rows="1" autosize type="textarea" placeholder="请输入" />
          </van-dialog>
        </van-tab>
        <van-tab background="black" :title="$t('message.home.list')">
          <div class="right" v-show="flagv == false">
            <ul v-if="isShow" class="content" style="position: relative; overflow: hidden">
              <li
                v-for="(crea, index) in VoteResultList"
                :key="index"
                style="position: relative; padding: 5"
                :style="{
                  color: activeColor(),
                  fontSize: fontSize(crea.voteNum) + 'px',
                  top: top() + 'px',
                  left: left() + 'px',
                  pxdisplay: 'inline-block'
                }"
              >
                {{ crea.areaName }}
              </li>
            </ul>
            <div class="right" v-else style="color: #808080; margin: 50px auto; text-align: center">
              暂无数据
            </div>
          </div>
          <div
            class="right"
            v-show="flagv == true"
            style="color: #808080; margin: 50px auto; text-align: center"
          >
            暂无数据
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="buttom">
      <div class="btn_t" v-show="areashow == false">
        <van-button
          color="linear-gradient(to left, #6688FF, #3360FF)"
          round
          type="info"
          @click="submit"
        >
          {{ $t('message.home.submit_vote') }}
        </van-button>
      </div>
      <div class="btn_y" v-show="areashow == true">
        <!-- <van-button  color="linear-gradient(to left, #6688FF, #3360FF)" round type="info" @click="submit">已投票
            </van-button> -->
        <span> {{ $t('message.home.Voted') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllAreaName, updateVote, getVisualVoteResult } from '@/api/common'
import { insertAreaName } from '@/api/activity'
import { Toast } from 'vant'
export default {
  components: {},
  created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    this.getAllAreaName()
    this.getVisualVoteResult()
    //this.updateVote()
  },
  data() {
    //这里存放数据
    return {
      resultListNew: [],
      areashow: '',
      flagv: true,
      message: '',
      billist: [],
      areaNamelist: [],
      VoteResultList: [],
      result: [],
      show: false,
      addParam: {
        divisionId: 0,
        h5VoteResultList: [],
        listId: 0
      },
      listDivisionAddParam: {
        areaNameList: [],
        divisionId: 0,
        listId: 0
      },
      arealist: [],
      fiaTwo: false,
      isShow: false
    }
  },
  //监听属性 类似于data概念
  computed: {
    id() {
      return this.$route.query.listid
    },
    divisionId() {
      return this.$route.query.divisionId
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async getAllAreaName() {
      const { data: res } = await getAllAreaName({ divisionId: this.divisionId, listId: this.id })
      if (res.resultCode == 200) {
        if (res.data.h5VoteResultList == null) {
          this.flagv = false
          this.billist = res.data
          this.areashow = this.billist.voteStatus
        } else {
          this.billist = res.data
          this.areaNamelist = res.data.h5VoteResultList
        }
      }
    },
    chang() {
      this.show = true
    },
    async submit() {
      if (this.listId != '') {
        this.addParam.listId = this.id
        this.addParam.divisionId = this.divisionId
      }

      if (this.addParam.h5VoteResultList.length > 0) {
        const { data: res } = await updateVote(this.addParam)
        if (res.resultCode == 200) {
          this.areashow = this.billist.voteStatus
          this.$router.go(0)
        }
      }
    },
    async getVisualVoteResult() {
      const { data: res } = await getVisualVoteResult({
        listId: this.id,
        divisionId: this.divisionId
      })
      console.log(res)
      if (res.resultCode == 200) {
        this.VoteResultList = res.data.visualVoteResultList
        if (res.data.visualVoteResultList != [] && res.data.visualVoteResultList.length != 0) {
          this.fiaTwo = true
        } else {
          this.fiaTwo = false
        }
        this.isShow = res.data.isShow
      }
    },
    activeColor() {
      var color = ['#2d8cf0', '#2db7f5', '#19be6b', '#ff9900', '#ed4014', '#17233d']
      var i = Math.floor(Math.random() * 6)
      return color[i]
    },
    // 高频词汇动态文字大小
    fontSize(x) {
      return 16 + +3 * x
    },
    // 高频词汇动态文字位置
    top() {
      return Math.random() * 0
    },
    left() {
      return 10 + Math.random() * 200
    },
    //给 addParam赋值
    toggle(index) {
      this.$refs.checkboxes[index].toggle()
    },
    itemClick() {
      console.log(this.result)
      if (this.result.length > 0) {
        this.addParam.h5VoteResultList = this.result
      }
    },
    cancelClick() {
      this.show = false
    },
    async chargeBtn() {
      if (this.areaNamelist.length <= 10) {
        const query = {
          name: this.message,
          sort: this.areaNamelist.length + 1,
          listStatus: this.areaNamelist[0].listStatus
        }
        this.listDivisionAddParam.areaNameList.push(query)
        this.listDivisionAddParam.listId = this.id
        this.listDivisionAddParam.divisionId = this.divisionId
        this.listDivisionAddParam.userDefined = this.billist.userDefined
        console.log(this.listDivisionAddParam)
        const { data: res } = await insertAreaName(this.listDivisionAddParam)
        if (res.resultCode === 200) {
          this.show = false
          Toast.success('新增成功！')
          this.getAllAreaName()
          this.message = ''
          this.listDivisionAddParam.areaNameList = []
        }
      } else {
        Toast.success('超出上限！')
      }
    }
  }
  //生命周期 - 创建完成(可以访问当前this实例)
}
</script>
<style lang="less" scoped>
* {
  margin: 0px;
  padding: 0px;
}

.division_vote {
  // width: 100%;
  height: 100%;
  position: relative;
}

.imgvotes {
  width: 100%;
  overflow: hidden;
  height: 168px;
  position: relative;

  img {
    width: 100%;
    overflow: hidden;
    height: 168px;
  }

  span {
    position: absolute;
    display: block;
    width: 42px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    color: #fff;
    font-size: 10px;
    font-weight: 400;
    border-radius: 4px;
    left: 12px;
    top: 12px;
  }

  .page_data_item_img1 {
    background-color: #359eff;
  }

  .page_data_item_img2 {
    background-color: #fff;
    color: #3c3b3f;
  }
  .page_data_item_img3 {
    background-color: #bbbbbb;
  }
}

.divisionName {
  width: 100%;
  height: 60px;
  z-index: 1;
  position: relative;
  overflow: hidden;
  padding: 10px 12px;
  border-radius: 12px;
  background-color: #fff;
  box-sizing: border-box;
  margin-top: -30px;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 144.5%;
  padding: 15px 0px;

  letter-spacing: -0.3px;

  p {
    color: #1a1a1a;
    padding-left: 20px;
    padding-bottom: 10px;
  }
}

.tab_listvote {
  border-top: 10px solid #efefef;

  .van-tab--active {
    background: #3067de;
    color: white;
  }

  .van-tabs__line {
    background: none;
  }

  .left {
    width: 100%;
    text-align: center;
  }
}
/deep/.van-tabs__content {
  padding-bottom: 150px;
}
.zdy {
  width: 284px;
  height: 36px;
  /* 主色 */
  border: 1px solid #3562ff;
  border-radius: 4px;
  color: #3562ff;
  text-align: center;
  line-height: 36px;
  margin: 0px auto;
  margin-top: 11px;
}

.area_left {
  // height: 255px;
  // overflow: hidden;
  width: 100%;
  margin: 0px auto;

  overflow-y: scroll;

  // display: flex;
  // justify-content: space-between;

  .van-cell__title {
    // position: relative;
    // left: 60px;
    text-align: center;
  }

  .van-checkbox {
    position: relative;
    right: 288px;
  }
}

.buttom {
  position: fixed;
  bottom: 0%;
  width: 100%;
  text-align: center;
  height: 80px;
  line-height: 80px;
  left: 50%;
  background-color: white;
  transform: translate(-50%);
  .btn_y {
    display: flex;
    justify-content: center;
    span {
      display: block;
      height: 36px;
      width: 223.4860382080078px;
      border-radius: 16px;
      text-align: center;
      background: #dfdfdf;
      border-radius: 16px;
      line-height: 36px;
      color: #bbbbbb;
    }
  }
}

.van-checkbox__icon--round .van-icon {
  margin-top: 2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  line-height: 15px;
}

.van-cell {
  //width: 284px;
  height: 36px;
  line-height: 36px;
}

.van-button--round {
  height: 36px;
  width: 223.4860382080078px;
}
</style>
